import './VideoTile.css';
import React from 'react';
import { get, injectImageResolution } from '../../utils';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import Video from '../atoms/Video';
import { tealiumCheckRightTextClick, tealiumClickFunc, tealiumMergeClickData, tealiumMergeClickNewData } from '../../utils/tealium';
import LazyPicture from '../atoms/LazyPicture';
import ScrollAnimation from 'react-animate-on-scroll';
import { convertToAnalyticObject } from '../../utils/analytics';
const VideoTile = _ref => {
  let {
    fields,
    params
  } = _ref;
  const left = params !== undefined && params['Left Media'] === '1' ? true : false;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (!fields) {
    console.info('VideoTile component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[VideoTile component is empty: please provide data source]");
    }
    return null;
  }
  const title = get(fields, 'data.item.title.jss', '');
  const description = get(fields, 'data.item.description.jss', '');
  const videoSrc = get(fields, 'data.item.video.jss.value.href', '');
  const videoType = get(fields, 'data.item.video.jss.value.linktype', '');
  const src = get(fields, 'data.item.previewImage.jss.value.src', '');
  const alt = get(fields, 'data.item.previewImage.jss.value.alt', '');
  const hasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  const hasDescription = Boolean(get(fields, 'data.item.description.jss.value'));
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: `${left ? '' : 'leftStyles'} row`
  }, /*#__PURE__*/React.createElement("div", {
    className: hasTitle || hasDescription ? 'col-xs-12 col-md-12 col-lg-8 col-xl-8' : 'col-xs-12 col-md-12 col-lg-12 col-xl-12'
  }, /*#__PURE__*/React.createElement("div", {
    className: hasTitle || hasDescription ? 'mediaContent' : 'withoutMedia'
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    className: "picture"
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 992px)",
    srcSet: `${injectImageResolution(src, 1420, 799)}`
  }), /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: `${injectImageResolution(src, 700, 700)}`
  }), /*#__PURE__*/React.createElement("img", {
    src: `${injectImageResolution(src, 325, 325)}`,
    alt: alt
  })), /*#__PURE__*/React.createElement(Video, {
    buttonTopLeftAlignment: true,
    buttonFilled: true,
    videoSrc: videoSrc,
    videoType: videoType,
    videoFullHeight: true,
    click: val => {
      val === 'Play' ? tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['playVideoTitleAnalytics'], params), title.value) : tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['stopVideoTitleAnalytics'], params), title.value);
    }
  }))), hasTitle || hasDescription ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "content col-xs-12 col-md-12 col-lg-3 col-xl-3"
  }, hasTitle ? /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    className: `${left ? '' : 'titleLeft'} title`,
    field: title
  })) : null, hasDescription ? /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement("div", {
    onClick: e => tealiumCheckRightTextClick(e, tealiumMergeClickData(eventsAnalytics['richTextAnalytics'], params), title.value)
  }, /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    className: `${left ? '' : 'descriptionLeft'} description`,
    field: description
  }))) : null)) : null))))))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true
  }, children);
};
const commonStyles = "c1barlap";
const ltrStyles = "lw6tnvw";
const rtlStyles = "r117m7oo";
export default VideoTile;